import React, { useState } from "react";
import { addToLegacyBlacklist, getCardKeyFromFields } from "../data/legacyBlacklist";
import { useRole } from "../data/useRole";
import "./ProductCard.css";

export default function LegacyFormulaCard({ record, onBlacklisted, onConvert, blacklistSet }) {
  const [blacklisting, setBlacklisting] = useState(false);
  const [done, setDone] = useState(false);
  const { canEdit } = useRole();

  // Create a unique key for this record (same format used in Firestore)
  const cardString =
    record.raw ||
    record.color ||
    record.name + (record.info ? JSON.stringify(record.info) : "");
  const normalizedKey = getCardKeyFromFields(record);

  // ✅ Determine if already blacklisted globally
  const isAlreadyBlacklisted = blacklistSet?.has(normalizedKey);

  const handleBlacklist = async () => {
    if (blacklisting || done || isAlreadyBlacklisted) return;
    setBlacklisting(true);
    try {
      await addToLegacyBlacklist(cardString, record.name);
      setDone(true);
      if (onBlacklisted) onBlacklisted();
    } catch (err) {
      alert("Failed to blacklist: " + (err?.message || err));
    }
    setBlacklisting(false);
  };

  return (
    <article className="product-card-box bigdb__card" style={{ position: "relative" }}>
      <div className="product-card-box__head">
        <h3 className="product-card-box__name bigdb__name">{record.name}</h3>
      </div>

      {!!(record.info && record.info.length) && (
        <div className="bigdb__info">
          {record.info.map((line, j) => (
            <p key={j} className="bigdb__info-line">
              {line}
            </p>
          ))}
        </div>
      )}

      {/* Badge */}
      <span
        className="product-card-box__btn product-card-box__btn--danger"
        style={{
          position: "absolute",
          bottom: 10,
          right: 10,
          pointerEvents: "none",
          fontWeight: 700,
          fontSize: "0.95em",
          opacity: 0.84,
          border: "none",
          minWidth: "auto",
          padding: "3px 13px",
          userSelect: "none",
          cursor: "default",
        }}
      >
        Legacy
      </span>

      {/* Blacklist Button */}
      {canEdit && (
        <button
          className="product-card-box__btn product-card-box__btn--danger"
          style={{
            marginTop: 12,
            width: "48%",
            display: "block",
            marginLeft: 0,
            marginRight: "auto",
          }}
          disabled={blacklisting || done || isAlreadyBlacklisted}
          onClick={handleBlacklist}
          title="Blacklist this formula (migrate to new DB first!)"
        >
          {isAlreadyBlacklisted || done
            ? "Blacklisted!"
            : blacklisting
            ? "Blacklisting..."
            : "Blacklist"}
        </button>
      )}

      {/* Convert Button */}
      <button
        className="product-card-box__btn"
        style={{
          marginTop: 10,
          width: "48%",
          display: "block",
          marginLeft: 0,
        }}
        onClick={() => onConvert && onConvert(record)}
      >
        Convert
      </button>
    </article>
  );
}
